module.exports = __webpack_public_path__ + "assets/-_9.501b595a.svg";